@let showAlteredBorder = hasHeadline();
<div>
  @for (segment of upperSegments(); track $index) {
    <div
      class="upper-ticket-segment{{ formattedSuffix() }} p-6"
      [ngClass]="{
        'rounded-t-2xl': $index === 0 && !showAlteredBorder,
      }"
      [style.background-color]="styling().backgroundColor"
      [style.border-left-width]="styling().borderWidth"
      [style.border-right-width]="styling().borderWidth"
      [style.border-top-width]="showAlteredBorder ? 0 : styling().borderWidth"
      [style.border-color]="corporateDesign.primaryBorderColor()"
      [style.margin-bottom]="'-' + styling().borderWidth + ''"
      [style.border-top-left-radius]="
        showAlteredBorder ? 0 : corporateDesign.borderRadius()
      "
      [style.border-top-right-radius]="
        showAlteredBorder ? 0 : corporateDesign.borderRadius()
      ">
      <ng-container
        *ngTemplateOutlet="
          upperTicketElement();
          context: { data: segment, index: $index }
        "></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="divider"></ng-container>
  }
  <div
    class="lower-ticket-segment{{ formattedSuffix() }} rounded-b-2xl p-6"
    [style.background-color]="styling().backgroundColor"
    [style.border-bottom-width]="styling().borderWidth"
    [style.border-left-width]="styling().borderWidth"
    [style.border-right-width]="styling().borderWidth"
    [style.border-color]="corporateDesign.primaryBorderColor()"
    [style.border-bottom-left-radius]="corporateDesign.borderRadius()"
    [style.border-bottom-right-radius]="corporateDesign.borderRadius()">
    <ng-content select="[lower]"></ng-content>
  </div>
</div>

<ng-template #divider>
  <div class="relative flex flex-row justify-between">
    <div
      class="z-1 box-border rounded-r-2xl py-3 pl-3"
      [style.border-top-width]="styling().borderWidth"
      [style.border-right-width]="styling().borderWidth"
      [style.border-bottom-width]="styling().borderWidth"
      [style.border-color]="corporateDesign.primaryBorderColor()"></div>
    <div
      class="absolute -left-3 box-border rounded-r-2xl p-3"
      [style.top]="'-0px'"
      [style.bottom]="'-0px'"
      [style.box-shadow]="'10px 0 0 0 ' + styling().backgroundColor"></div>
    <div
      class="z-1 w-[calc(100%+2rem)] justify-between"
      [style.background-color]="styling().backgroundColor">
      <div
        class="mt-3"
        [style.border-image-source]="
          'repeating-linear-gradient(90deg, ' +
          corporateDesign.primaryBorderColor() +
          ' 0, ' +
          corporateDesign.primaryBorderColor() +
          ' 8px, transparent 8px, transparent 16px)'
        "
        [style.border-image-slice]="'2'"
        [style.border-top-width]="styling().borderWidth"></div>
    </div>
    <div
      class="z-1 rounded-l-2xl py-3 pr-3"
      [style.border-bottom-width]="styling().borderWidth"
      [style.border-left-width]="styling().borderWidth"
      [style.border-top-width]="styling().borderWidth"
      [style.border-color]="corporateDesign.primaryBorderColor()"></div>
    <div
      class="absolute -right-3 box-border rounded-l-2xl p-3"
      [style.top]="'-0px'"
      [style.bottom]="'-0px'"
      [style.box-shadow]="'-10px 0 0 0 ' + styling().backgroundColor"></div>
  </div>
</ng-template>
